import './index.scss'
import {PaidIcon} from '../../../icons'
import {useDispatch, useSelector} from 'react-redux'
import {logUpgradePlanNavigation} from '../../../stores/customer-settings'
import {Link} from 'react-router-dom'
import {routes} from '../../../routes'
import classNames from 'classnames'
import NavigationHelper from '../../../utils/navigation'
import {useNamespaceTranslations} from '../../../utils/hooks/useNamespacesTranslations'
import localStorageKeys from '../../../utils/localStorageKeys'

const ForPaid = ({forPaidText, isExceeded, isInfo = false, className = ''}) => {
    const dispatch = useDispatch()
    const text = useNamespaceTranslations('for-paid')
    const languageOptions = useNamespaceTranslations('footer')?.language_options
    const lang = localStorage.getItem(localStorageKeys.LANGUAGE)
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    const postAction = () => {
        dispatch(logUpgradePlanNavigation())
    }

    return (
        <div className={classNames({
            'for-paid': true,
            'exceeded': isExceeded,
            'dark': isDarkMode
        }, className
        )}>
            {!isInfo && (
                <span className="paid-icon">
                    <PaidIcon/>
                </span>
            )}
            <p className="for-paid-text">{forPaidText} {
                !isInfo && (
                    <>
                        <Link onClick={postAction} to={NavigationHelper.getLocalizedPath(routes.plans.paths)}>{text.upgrade_plan}</Link>
                        <span> {text.or_contact} </span>
                        <a href={`mailto:${text.email}`}>{text.email}</a>
                        {lang === languageOptions?.az?.value ? <span>{text.long_contact_us_info}</span> : '.'}
                    </>
                )
            }
            </p>
        </div>
    )
}

export default ForPaid
